module.exports = __webpack_public_path__ + "img/travel_thumbnail-600x450.0ad81989.jpg";